import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationCircle } from 'react-icons/all';
import { useDispatch, useSelector } from 'react-redux';
import { CustomsInstructionsForHandling } from '../../../../@posturinn/client-react';
import { closeAllModals } from '../../../../actions/modalActions';
import { addShipmentCustomsInformation } from '../../../../actions/shipmentsActions';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import IUserProfileReducer from '../../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../../reducers';
import Button from '../../../base/button/button';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import FormikRadio from '../../../base/forms/formikRadio';
import { StyledFormikField } from '../../../base/forms/input';
import { A } from '../../../base/typography';
import * as StyledModals from '../myShipmentsModals.styles';
import { dontHaveFilesSchema } from './dontHaveFiles.schema';

interface Props {}

const AttachFiles: FC<Props> = () => {
	const { t } = useTranslation(['myShipments', 'sendReceipt']);
	const dispatch = useDispatch<any>();
	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	const { modalHeading, shipmentId, page } = useSelector(({ modalReducer }) => modalReducer);
	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);
	const { modalSubmitPending, modalSubmitError, modalSubmitErrorDetails } = userProfileReducer;
	const { emailVerified, email } = userProfileReducer?.userProfile;

	const submit = values => {
		let cifh;
		switch (values.instructionsToStaff) {
			case 'openUp':
				cifh = CustomsInstructionsForHandling.AllowToOpen;
				break;
			case 'gift':
				cifh = CustomsInstructionsForHandling.Gift;
				break;
			default:
				cifh = CustomsInstructionsForHandling.Other;
				break;
		}
		dispatch(addShipmentCustomsInformation(shipmentId, values.additionalInformation, [], cifh, page, values.email));
	};

	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{modalHeading}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>
			{modalSubmitError && (
				<StyledModals.ErrorMessage>
					<FaExclamationCircle />
					<div>{modalSubmitErrorDetails !== '' ? modalSubmitErrorDetails : t('genericError')}</div>
				</StyledModals.ErrorMessage>
			)}
			<Formik
				initialValues={{ gift: false, files: [], email: email }}
				enableReinitialize
				validationSchema={dontHaveFilesSchema}
				onSubmit={submit}>
				{({ setFieldValue, values }) => (
					<Form>
						<FormikFieldWrapper name="instructionsToStaff" languageComponent="sendReceipt">
							<FormikRadio
								id="openUp"
								name="instructionsToStaff"
								label={t('sendReceipt:permissionToOpen')}
								setFieldValue={setFieldValue}
							/>
							<FormikRadio
								id="gift"
								name="instructionsToStaff"
								label={t('sendReceipt:gift')}
								setFieldValue={setFieldValue}
							/>
							<FormikRadio
								id="other"
								name="instructionsToStaff"
								label={t('sendReceipt:other')}
								setFieldValue={setFieldValue}
							/>
						</FormikFieldWrapper>
						<FormikFieldWrapper
							label={
								values.instructionsToStaff === 'openUp'
									? t('filesAdditionalInformation')
									: `${t('filesAdditionalInformation')} *`
							}
							name="additionalInformation"
							languageComponent="myShipments"
							marginTop="3rem"
							smallLabel>
							<StyledFormikField
								type="text"
								id="additionalInformation"
								name="additionalInformation"
								placeholder={t('filesAdditionalInformation')}
							/>
						</FormikFieldWrapper>
						<FormikFieldWrapper
							name="email"
							languageComponent="myShipments"
							smallLabel
							label={`${t('email')} *`}>
							<StyledFormikField
								type="text"
								id="email"
								name="email"
								placeholder={t('email')}
								disabled={emailVerified}
							/>
						</FormikFieldWrapper>
						<Button primary type="submit" isLoading={modalSubmitPending}>
							{t('submit')}
						</Button>
					</Form>
				)}
			</Formik>
		</StyledModals.Wrapper>
	);
};

export default AttachFiles;
